import { ApolloClient } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import getApolloClient from "../client";

const MUTATION = graphql(`
  mutation multipartUpload(
    $id: ID!
    $finished: Boolean!
    $chunkCount: Int
    $uploadId: String
    $parts: [RecordUploadPartInput!]
  ) {
    upload: multipartUploadRecord(
      id: $id
      finished: $finished
      chunkCount: $chunkCount
      uploadId: $uploadId
      parts: $parts
    ) {
      uploadId
      uploadPaths
    }
  }
`);

type Data = ResultOf<typeof MUTATION>;
type Variables = VariablesOf<typeof MUTATION>;

/** One uploaded part of a multipart record upload, as `RecordUploadPartInput` of the schema. */
export type RecordUploadPartInput = NonNullable<Variables["parts"]>[number];

export const useRecordMultipartUploadMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};

export const recordMultipartUploadMutate = (
  options: Omit<ApolloClient.MutateOptions<Data, Variables>, "mutation">,
): Promise<ApolloClient.MutateResult<Data>> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "searchRecords",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return getApolloClient().mutate<Data, Variables>({
    ...options,
    mutation: MUTATION,
  });
};
